export default __webpack_public_path__ + "static/media/explore-mobile-2.6823928e.png";